import { VisitStatusEnum } from '@app/customer-account/models/visit-status.enum';
import { PaymentStatus } from '@app/shared/enums/payment-status.enum';
import { PaymentType } from '@app/shared/enums/payment-type.enum';
import { VisitTreatmentDetailsApiModel } from './visit-treatment-details.model';

export interface IVisitDetails {
  visitId: string;
  visitDate: Date;
  visitStatus: VisitStatusEnum;
  treatments: VisitTreatmentDetailsApiModel[];
  salonId: string;
  salonName: string;
  salonNameAlias: string;
  salonCity: string;
  salonStreet: string;
  salonHouseNumber: string;
  salonHouseSubNumber: string;
  salonAllowsGifts: boolean;
  salonLogoUrl: string;
  employeePhotoUrl: string;
  visitRemarks: string;
  paymentType: PaymentType;
  paymentStatus: PaymentStatus;
  customerEmail: string;
  bookingReturnUrl?: string;
  wasRoutedBySalonId?: boolean;
  canRedirectToSalonWebpageOnRouteBySalonId?: boolean;
}
